(function ($) {


    // ページ内リンクにスムーズなスクロール
    function toHerf() {
        var $toHerf = $(".page-href .list a, .js-href a, a.to_href");
        $toHerf.on("click", function (e) {
            $("body").removeClass("show_menu");
            if (location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') && location.hostname == this.hostname) {
                var $target = $(this.hash);
                $target = $target.length && $target || $('[name=' + this.hash.slice(1) + ']');

                if ($target.length) {
                    var targetOffset = $target.offset().top;
                    $('html,body').animate({
                            scrollTop: targetOffset
                        },
                        1000);
                    return false;
                }
            }
        })
    }


    // ページトップ
    function scrollToTop() {
        $('.pagetop').on('click', function (e) {
            e.preventDefault(); // デフォルトのリンク動作を防止
            $('html, body').animate({
                scrollTop: 0
            }, 1000);
        });
    }



    // スプラッシュ
    function splash() {
        // 同じ日付で2回目以降ならローディング画面非表示の設定
        var splash_text = $.cookie('accessdate'); // キーが入っていれば年月日を取得
        var myD = new Date(); // 日付データを取得
        var myYear = String(myD.getFullYear()); // 年
        var myMonth = String(myD.getMonth() + 1); // 月
        var myDate = String(myD.getDate()); // 日

        if (splash_text != myYear + myMonth + myDate) { // cookieデータとアクセスした日付を比較
            $("#splash").css("display", "block"); // 1回目はローディングを表示

            var splashDuration = 3200; // スプラッシュ全体の表示時間（ミリ秒）
            var intervalDuration = 100; // カウンタの更新間隔（ミリ秒）
            var totalSteps = splashDuration / intervalDuration; // カウントアップのステップ数
            var counter = 0; // カウンタの初期化
            var counterElement = $("#counter");

            var counterInterval = setInterval(function () {
                counter++;
                var percentage = Math.min(Math.floor((counter / totalSteps) * 100), 100);
                counterElement.text(percentage + "%");
                if (percentage >= 100) {
                    clearInterval(counterInterval);
                    setTimeout(function () {
                        $("#splash").fadeOut(1000, function () { // 1000ミリ秒（1秒）かけて画面がフェードアウト
                            $.cookie('accessdate', myYear + myMonth + myDate); // accessdateキーで年月日を記録
                        });
                    }, 800); // 100%になった後、0.5秒遅延させる
                }
            }, intervalDuration);

            // ここから追加
            window.onload = function () {
                setTimeout(function () {
                    $("#splash_logo").fadeIn(1000, function () { // 1000ミリ秒（1秒）かけてロゴがフェードイン
                        setTimeout(function () {
                            $("#splash_logo").fadeOut(1000); // 1000ミリ秒（1秒）かけてロゴがフェードアウト
                        }, 1000); // 1000ミリ秒（1秒）後に処理を実行
                    });
                }, 1400); // 1000ミリ秒（1秒）後に処理を実行
            };
            // ここまで追加
        } else {
            $("#splash").css("display", "none"); // 同日2回目のアクセスでローディング画面非表示
        }
    }
    if (typeof window.Swiper !== 'undefined') {
    const planlist = new Swiper('.p-planlist', {
        spaceBetween: 10,
        slidesPerView: 1.25,
        centeredSlides : true,
        loop: true,


        pagination: {
          el: '.swiper-pagination-planlist',
    clickable: true,
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
      });

      // 前撮りロケーション詳細: おすすめポイントのカルーセル
      const pointlist = new Swiper('.p-pointlist', {
        spaceBetween: 16,
        slidesPerView: 1.15,
        centeredSlides: true,
        loop: true,

        pagination: {
          el: '.swiper-pagination-pointlist',
          clickable: true,
          renderBullet: function (index, className) {
            var titles = [];
            try {
              titles = JSON.parse(this.el.getAttribute('data-point-titles') || '[]');
            } catch (e) {}
            var label = (titles[index] && String(titles[index]).trim())
              ? String(titles[index])
              : ('0' + (index + 1)).slice(-2);
            var div = document.createElement('div');
            div.textContent = label;
            return '<span class="' + className + '">' + div.innerHTML + '</span>';
          },
        },
        navigation: {
          nextEl: '.p-pointlist .swiper-button-next',
          prevEl: '.p-pointlist .swiper-button-prev',
        },
      });

      // フォトギャラリー: 魅力コンテンツのカルーセル
      document.querySelectorAll('.js-gallery-term-slider').forEach(function (slider) {
        var slides = slider.querySelectorAll('.swiper-slide');
        var carousel = slider.closest('.p-gallery-term__carousel');

        new Swiper(slider, {
          spaceBetween: 10,
          slidesPerView: 1.25,
          centeredSlides: true,
          initialSlide: 0,
          loop: slides.length > 1,
          grabCursor: true,
          watchOverflow: true,

          pagination: {
            el: carousel ? carousel.querySelector('.p-gallery-term__pagination') : null,
            clickable: true,
            renderBullet: function (index, className) {
              return '<span class="' + className + '">' + ('0' + (index + 1)).slice(-2) + '</span>';
            },
          },
          navigation: {
            nextEl: slider.querySelector('.p-gallery-term__next'),
            prevEl: slider.querySelector('.p-gallery-term__prev'),
          },
        });
      });


      // 記事本文の貸出アイテム: 止まらずに流れるカルーセル
      document.querySelectorAll('.js-rentallist').forEach(function (slider) {
        new Swiper(slider, {
          loop: true,
          slidesPerView: 'auto',
          spaceBetween: 6,
          speed: 5000, // 1枚ぶん流れるのにかかる時間(大きいほどゆっくり)
          allowTouchMove: false,
          autoplay: {
            delay: 0, // 途切れなくループ
            disableOnInteraction: false,
          },
        });
      });

      // 記事本文の写真スライダー: 1ページに複数置くので、1つずつ初期化する
      document.querySelectorAll('.js-photoslider').forEach(function (slider) {
        var slides = slider.querySelectorAll('.swiper-slide');
        // ページネーションは swiper の外(親要素)に置いている
        var outer = slider.closest('.p-photoslider__outer');

        new Swiper(slider, {
          spaceBetween: 10,
          slidesPerView: 1.25,
          centeredSlides: true,
          loop: slides.length > 2,
          grabCursor: true,
          watchOverflow: true,

          pagination: {
            el: outer ? outer.querySelector('.p-photoslider__pagination') : null,
            clickable: true,
            renderBullet: function (index, className) {
              return '<span class="' + className + '">' + ('0' + (index + 1)).slice(-2) + '</span>';
            },
          },
          navigation: {
            nextEl: slider.querySelector('.p-photoslider__next'),
            prevEl: slider.querySelector('.p-photoslider__prev'),
          },
        });
      });


          const voicelist = new Swiper('.p-voicelist', {
        spaceBetween: 8,
        slidesPerView: 1.25,
        centeredSlides : true,
        loop: true,


        pagination: {
          el: '.swiper-pagination-voicelist',
    clickable: true,
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
      });

          const bloglist = new Swiper('.p-bloglist', {
        spaceBetween: 10,
        slidesPerView: 1.3,
        loop: true,


        pagination: {
          el: '.swiper-pagination',
    clickable: true,
        },

      });

      const gallerylist01 = new Swiper(".p-gallerylist-01", {
  loop: true, // ループ有効
    slidesPerView: 'auto', // 画像の比率を保つために自動スライド幅
          spaceBetween: 6,

  speed: 45000, // ループの時間
  allowTouchMove: false, // スワイプ無効
  autoplay: {
    delay: 0, // 途切れなくループ
  },
});

      const gallerylist02 = new Swiper(".p-gallerylist-02", {
  loop: true, // ループ有効
    slidesPerView: 'auto', // 画像の比率を保つために自動スライド幅
          spaceBetween: 6,

  speed: 45000, // ループの時間
  allowTouchMove: false, // スワイプ無効
  autoplay: {
    delay: 0, // 途切れなくループ
        reverseDirection: true, // 逆方向有効化

  },
});
    }
      


      
      

    $(function () {

        toHerf();
        scrollToTop(); // 
        // splash(); // 
    });






})(jQuery);




document.addEventListener("DOMContentLoaded", function() {
    const tabButtons = document.querySelectorAll(".c-tabs__button");
    const tabContents = document.querySelectorAll(".c-tabs__content");

    tabButtons.forEach(button => {
        button.addEventListener("click", () => {
            tabButtons.forEach(btn => btn.classList.remove("is-active"));
            tabContents.forEach(content => content.classList.remove("is-active"));

            button.classList.add("is-active");
            const tabContent = document.getElementById(button.dataset.tab);
            tabContent.classList.add("is-active");
        });
    });
});

document.addEventListener("DOMContentLoaded", function() {
    const accordionItems = document.querySelectorAll(".c-accordion__item");

    accordionItems.forEach(item => {
        const header = item.querySelector(".c-accordion__header");
        const content = item.querySelector(".c-accordion__content");
        const toggle = item.querySelector(".c-accordion__toggle");
        // 1ページに複数の .c-accordion がある記事でも、開閉は同じグループ内だけにとどめる
        const group = item.closest(".c-accordion") || document;

        header.addEventListener("click", function() {
            const isOpen = content.classList.contains("is-open");

            // 同じグループのアコーディオンをすべて閉じる
            group.querySelectorAll(".c-accordion__item").forEach(i => {
                i.querySelector(".c-accordion__content").classList.remove("is-open");
                i.querySelector(".c-accordion__toggle").textContent = "+";
            });

            // クリックされたアコーディオンの開閉をトグルする
            if (!isOpen) {
                content.classList.add("is-open");
                toggle.textContent = "−";
            } else {
                content.classList.remove("is-open");
                toggle.textContent = "+";
            }
        });
    });
});


        // ギャラリー詳細のFV画像は独自の入場アニメーションを使うため simpleParallax の対象外にする
        // (single-gallery では .thumbnail はFV画像のみなのでまるごとスキップする)
        const image = document.getElementsByClassName('thumbnail');
        if (image.length && !document.body.classList.contains('single-gallery') && !document.body.classList.contains('single-gallery-location')) {
          new simpleParallax(image, {
            scale: 1.1
          });
        }


                const image2 = document.getElementsByClassName('thumbnail2');
        new simpleParallax(image2, {
          scale: 1.3
        });


        $(function () {
  var $demo1 = $('.p-gallery__single__list'); //コンテナとなる要素を指定

  if (!$demo1.length || typeof $.fn.imagesLoaded !== 'function' || typeof $.fn.masonry !== 'function') {
    return;
  }

  $demo1.imagesLoaded(function () { //imagesLoadedを使用し、画像が読み込みまれた段階でMasonryの関数を実行させる
    //Masonryの関数↓
    $demo1.masonry({ //オプション指定箇所
      itemSelector: '.js-item', //コンテンツを指定
      fitWidth: true, //コンテンツ数に合わせ親の幅を自動調整
      columnWidth: '.grid-sizer',
      gutter: '.gutter-sizer'

    });
  });
});
$(function () {

  function colorizeImage(image) {
    if (!image || image.classList.contains('colorize')) return;
    image.classList.add('colorize');
  }

  function initScrollAnimation() {
    var images = [];
    document.querySelectorAll('.scroll-area').forEach(function (scrollArea) {
      var image = scrollArea.querySelector('.monochrome');
      // .monochromeを持たない.scroll-areaで例外にならないようガード
      if (image) images.push(image);
    });

    if (!images.length) return;

    // IntersectionObserver非対応環境では即時表示
    if (!('IntersectionObserver' in window)) {
      images.forEach(colorizeImage);
      return;
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          colorizeImage(entry.target);
          observer.unobserve(entry.target);
        }
      });
    }, {
      // 画面に入る少し手前から発火させ、SPの慣性スクロールでも取りこぼさない
      rootMargin: '0px 0px -10% 0px',
      threshold: 0
    });

    images.forEach(function (image) {
      observer.observe(image);
    });
  }

  initScrollAnimation();
  // 後から差し込まれた要素(無限スクロール)からも再初期化できるよう公開
  window.wfInitScrollAnimation = initScrollAnimation;



});

// 前撮りレポートのフォトモーダル
$(function () {
  var lightbox = document.getElementById('js-lightbox');
  if (!lightbox) return;

  var lightboxImg = document.getElementById('js-lightbox-img');
  var lightboxImgNext = document.getElementById('js-lightbox-img-next');
  var lightboxAvif = document.getElementById('js-lightbox-avif');
  var lightboxAvifNext = document.getElementById('js-lightbox-avif-next');
  var lightboxCaption = document.getElementById('js-lightbox-caption');
  var lightboxCurrent = document.getElementById('js-lightbox-current');
  var lightboxCurrentNext = document.getElementById('js-lightbox-current-next');
  var lightboxTotal = document.getElementById('js-lightbox-total');
  var lightboxNavImg = document.getElementById('js-lightbox-nav-img');
  var lightboxNavImgNext = document.getElementById('js-lightbox-nav-img-next');
  var images = [];
  var currentIndex = -1;
  var isImageAnimating = false;

  function collectImages() {
    images = [];
    document.querySelectorAll('.js-item.scroll-area img').forEach(function (img) {
      var picture = img.closest('picture');
      var avifSource = picture ? picture.querySelector('source[type="image/avif"]') : null;
      images.push({
        src: img.getAttribute('src'),
        avifSrcset: avifSource ? (avifSource.getAttribute('srcset') || '') : '',
        alt: (img.getAttribute('alt') || '').trim(),
        caption: (img.getAttribute('data-caption') || '').trim()
      });
    });
    if (lightboxTotal) lightboxTotal.textContent = images.length;
  }

  function setAvifSource(source, srcset) {
    if (!source) return;
    if (srcset) {
      source.setAttribute('srcset', srcset);
      return;
    }
    source.removeAttribute('srcset');
  }

  function setNavImage(element, src) {
    if (!element) return;
    element.style.backgroundImage = src ? 'url("' + src.replace(/"/g, '\\"') + '")' : '';
  }

  function updatePhotoCount(index, direction, animate) {
    var nextText = String(index + 1);

    if (lightboxTotal) lightboxTotal.textContent = String(images.length);
    if (!animate) {
      if (lightboxCurrent) lightboxCurrent.textContent = nextText;
      if (lightboxCurrentNext) lightboxCurrentNext.textContent = nextText;
      lightbox.classList.remove('is-count-switching');
      return;
    }

    lightbox.style.setProperty('--count-enter-y', direction === 'prev' ? '-100%' : '100%');
    lightbox.style.setProperty('--count-leave-y', direction === 'prev' ? '100%' : '-100%');
    if (lightboxCurrentNext) lightboxCurrentNext.textContent = nextText;
    lightbox.classList.add('is-count-switching');

    window.setTimeout(function () {
      lightbox.classList.add('is-count-reset');
      if (lightboxCurrent) lightboxCurrent.textContent = nextText;
      lightbox.classList.remove('is-count-switching');
      if (lightboxCurrentNext) lightboxCurrentNext.textContent = nextText;
      lightbox.offsetHeight;
      lightbox.classList.remove('is-count-reset');
    }, 420);
  }

  function startImageSwitchWhenReady(callback) {
    var started = false;
    var start = function () {
      if (started) return;
      started = true;
      callback();
    };

    if (lightboxImgNext.decode) {
      lightboxImgNext.decode().then(start).catch(start);
      return;
    }
    if (lightboxImgNext.complete) {
      start();
      return;
    }
    lightboxImgNext.onload = start;
  }

  function showImage(index, direction, animate) {
    if (!images.length || isImageAnimating) return;

    var previousIndex = currentIndex;
    currentIndex = (index + images.length) % images.length;
    var image = images[currentIndex];

    if (lightboxCaption) {
      lightboxCaption.textContent = image.caption;
      lightboxCaption.hidden = image.caption === '';
    }
    updatePhotoCount(currentIndex, direction, animate && previousIndex !== -1);

    if (!animate || previousIndex === -1) {
      setAvifSource(lightboxAvif, image.avifSrcset);
      lightboxImg.src = image.src;
      lightboxImg.alt = image.alt;
      setAvifSource(lightboxAvifNext, '');
      lightboxImgNext.src = '';
      lightboxImgNext.alt = '';
      setNavImage(lightboxNavImg, image.src);
      setNavImage(lightboxNavImgNext, '');
      return;
    }

    isImageAnimating = true;
    lightbox.style.setProperty('--modal-enter-x', direction === 'prev' ? '-9%' : '9%');
    lightbox.style.setProperty('--modal-leave-x', direction === 'prev' ? '9%' : '-9%');
    setAvifSource(lightboxAvifNext, image.avifSrcset);
    lightboxImgNext.src = image.src;
    lightboxImgNext.alt = image.alt;
    setNavImage(lightboxNavImgNext, image.src);

    startImageSwitchWhenReady(function () {
      window.requestAnimationFrame(function () {
        lightbox.classList.add('is-switching');
        window.setTimeout(function () {
          lightbox.classList.add('is-image-reset');
          setAvifSource(lightboxAvif, image.avifSrcset);
          lightboxImg.src = image.src;
          lightboxImg.alt = image.alt;
          setAvifSource(lightboxAvifNext, '');
          lightboxImgNext.src = '';
          lightboxImgNext.alt = '';
          setNavImage(lightboxNavImg, image.src);
          setNavImage(lightboxNavImgNext, '');
          lightbox.classList.remove('is-switching');
          lightbox.offsetHeight;
          lightbox.classList.remove('is-image-reset');
          isImageAnimating = false;
        }, 540);
      });
    });
  }

  function openLightbox(index) {
    collectImages();
    showImage(index, 'next', false);
    lightbox.classList.add('is-open');
    lightbox.setAttribute('aria-hidden', 'false');
    document.body.classList.add('is-gallery-modal-open');
    document.body.style.overflow = 'hidden';
  }

  function closeLightbox() {
    lightbox.classList.remove('is-open', 'is-switching', 'is-count-switching');
    lightbox.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('is-gallery-modal-open');
    document.body.style.overflow = '';
    setAvifSource(lightboxAvif, '');
    setAvifSource(lightboxAvifNext, '');
    lightboxImg.src = '';
    lightboxImgNext.src = '';
    if (lightboxCaption) {
      lightboxCaption.textContent = '';
      lightboxCaption.hidden = true;
    }
    currentIndex = -1;
    isImageAnimating = false;
  }

  function prevImage() {
    showImage(currentIndex - 1, 'prev', true);
  }

  function nextImage() {
    showImage(currentIndex + 1, 'next', true);
  }

  // 画像クリックでライトボックスを開く
  $(document).on('click', '.js-item.scroll-area img', function () {
    collectImages();
    var src = $(this).attr('src');
    var idx = images.findIndex(function (image) {
      return image.src === src;
    });
    openLightbox(idx >= 0 ? idx : 0);
  });

  document.getElementById('js-lightbox-overlay').addEventListener('click', closeLightbox);
  document.getElementById('js-lightbox-close').addEventListener('click', closeLightbox);
  document.querySelectorAll('.js-lightbox-prev').forEach(function (button) {
    button.addEventListener('click', function (e) { e.stopPropagation(); prevImage(); });
  });
  document.querySelectorAll('.js-lightbox-next').forEach(function (button) {
    button.addEventListener('click', function (e) { e.stopPropagation(); nextImage(); });
  });

  document.addEventListener('keydown', function (e) {
    if (!lightbox.classList.contains('is-open')) return;
    if (e.key === 'Escape') closeLightbox();
    if (e.key === 'ArrowLeft') prevImage();
    if (e.key === 'ArrowRight') nextImage();
  });
});

$(function () {
  $('a[href^="#"]').click(function () {
    var href = $(this).attr("href");
    var target = $(href == "#" || href == "" ? 'html' : href);
    var position = target.offset().top;
　　 var speed = 500;
    $("html, body").animate({
      scrollTop: position
    }, speed, "swing");
    return false;
  });
});

$(function () {

// id="canvas" がページ内に複数ある(FV・サイトメニュー・下層h1など)ため、
// getElementById ではなく querySelectorAll で全て取得してまとめて描画する。
// モーダルの背景も同じ粒子表現を使うため、専用クラスのcanvasも対象に含める。
var canvases = Array.prototype.slice.call(document.querySelectorAll('#canvas, .js-grain-canvas'));
if (!canvases.length) return;

// change these settings
var patternSize = 400,
    patternRefreshInterval = 20,
    patternAlpha = 12; // int between 0 and 255,

var patternPixelDataLength = patternSize * patternSize * 4,
    patternCanvas,
    patternCtx,
    patternData,
    frame = 0;

var views = [];

window.addEventListener('load', function () {
    initCanvases();
    initGrain();
    requestAnimationFrame(loop);
});

// create canvases which will render the grain
function initCanvases() {
    views = canvases.map(function (canvas) {
        var view = {
            canvas: canvas,
            ctx: canvas.getContext('2d'),
            width: 0,
            height: 0
        };
        resizeView(view);
        return view;
    });
}

// モーダルは写真を開いた後に高さが決まるため、描画時点の表示寸法へ追従させる
function resizeView(view) {
    var width = Math.max(1, Math.round(view.canvas.clientWidth));
    var height = Math.max(1, Math.round(view.canvas.clientHeight));

    if (view.width === width && view.height === height) return;

    view.canvas.width = width;
    view.canvas.height = height;
    view.width = width;
    view.height = height;
}

// create a canvas which will be used as a pattern
function initGrain() {
    patternCanvas = document.createElement('canvas');
    patternCanvas.width = patternSize;
    patternCanvas.height = patternSize;
    patternCtx = patternCanvas.getContext('2d');
    patternData = patternCtx.createImageData(patternSize, patternSize);
}

// put a random shade of gray into every pixel of the pattern
function update() {
    var value;

    for (var i = 0; i < patternPixelDataLength; i += 4) {
        value = (Math.random() * 255) | 0;

        patternData.data[i    ] = value;
        patternData.data[i + 1] = value;
        patternData.data[i + 2] = value;
        patternData.data[i + 3] = patternAlpha;
    }

    patternCtx.putImageData(patternData, 0, 0);
}

// fill every canvas using the pattern
function draw() {
    views.forEach(function (view) {
        resizeView(view);
        view.ctx.clearRect(0, 0, view.width, view.height);

        view.ctx.fillStyle = view.ctx.createPattern(patternCanvas, 'repeat');
        view.ctx.fillRect(0, 0, view.width, view.height);
    });
}

function loop() {
    if (++frame % patternRefreshInterval === 0) {
        update();
        draw();
    }

    requestAnimationFrame(loop);
}

});



document.addEventListener('DOMContentLoaded', () => {
  const nextBlock = document.querySelector('.c-nextblock-inner');
  if (!nextBlock) return;

  const fadeDistance = 300; // フェードが開始される距離（最後からのpx）

  function handleScroll() {
    const scrollPosition = window.scrollY + window.innerHeight; // 現在のスクロール位置 + ビューポートの高さ
    const documentHeight = document.body.offsetHeight; // ドキュメント全体の高さ

    // ページの末尾からフェードを開始する位置
    const fadeStart = documentHeight - fadeDistance;

    if (scrollPosition >= fadeStart) {
      // スクロールがfadeStart以上になったらopacityを変化させる（0から1へ）
      const opacityValue = Math.min(1, (scrollPosition - fadeStart) / fadeDistance);
      nextBlock.style.opacity = opacityValue;
    } else {
      // それ以外の場合はopacityを0に保つ
      nextBlock.style.opacity = 0;
    }
  }

  // スクロールイベントをリッスン
  window.addEventListener('scroll', handleScroll);
});


$(function () {
  var menuToggle = document.querySelector('.c-button__menu');
  var siteMenuWrap = document.querySelector('.site-menu-wrap');
  var siteHeaderLogo = document.querySelector('.l-spbox .p-home__fv-bottom-top-left a');
  var siteHeaderLine = document.querySelector('.l-spbox .p-home__fv-bottom-top-right .c-button__line');
  var siteMenuScrollPosition = 0;

  function setSiteMenuFixedPosition(element, prefix) {
    if (!element) return;

    var rect = element.getBoundingClientRect();
    document.body.style.setProperty('--site-menu-' + prefix + '-top', rect.top + 'px');
    document.body.style.setProperty('--site-menu-' + prefix + '-left', rect.left + 'px');
    document.body.style.setProperty('--site-menu-' + prefix + '-right', (window.innerWidth - rect.right) + 'px');
  }

  function clearSiteMenuFixedPositions() {
    ['button', 'logo', 'line'].forEach(function (prefix) {
      document.body.style.removeProperty('--site-menu-' + prefix + '-top');
      document.body.style.removeProperty('--site-menu-' + prefix + '-left');
      document.body.style.removeProperty('--site-menu-' + prefix + '-right');
    });
  }

  function setSiteMenuOpen(isOpen) {
    if (!menuToggle || !siteMenuWrap) return;

    resetGalleryTree();

    if (isOpen) {
      setSiteMenuFixedPosition(menuToggle, 'button');
      setSiteMenuFixedPosition(siteHeaderLogo, 'logo');
      setSiteMenuFixedPosition(siteHeaderLine, 'line');
      siteMenuScrollPosition = window.pageYOffset || document.documentElement.scrollTop || 0;
      if (window.wfLenis && typeof window.wfLenis.stop === 'function') {
        window.wfLenis.stop();
      }
    }

    siteMenuWrap.classList.toggle('active', isOpen);
    menuToggle.classList.toggle('active', isOpen);
    document.body.classList.toggle('is-site-menu-open', isOpen);
    document.documentElement.classList.toggle('is-site-menu-open', isOpen);

    if (!isOpen) {
      if (window.wfLenis) {
        if (typeof window.wfLenis.resize === 'function') {
          window.wfLenis.resize();
        }
        if (typeof window.wfLenis.scrollTo === 'function') {
          window.wfLenis.scrollTo(siteMenuScrollPosition, { immediate: true, force: true });
        }
        if (typeof window.wfLenis.start === 'function') {
          window.wfLenis.start();
        }
      }
      window.scrollTo(0, siteMenuScrollPosition);
      clearSiteMenuFixedPositions();
    }

    menuToggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    menuToggle.setAttribute('aria-label', isOpen ? 'メニューを閉じる' : 'メニューを開く');
    siteMenuWrap.setAttribute('aria-hidden', isOpen ? 'false' : 'true');
  }

  if (menuToggle && siteMenuWrap) {
    menuToggle.addEventListener('click', function () {
      setSiteMenuOpen(!siteMenuWrap.classList.contains('active'));
    });

    siteMenuWrap.querySelectorAll('a').forEach(function (link) {
      link.addEventListener('click', function () {
        setSiteMenuOpen(false);
      });
    });

    window.addEventListener('pageshow', function (event) {
      if (event.persisted && siteMenuWrap.classList.contains('active')) {
        setSiteMenuOpen(false);
      }
    });

    window.addEventListener('pagehide', function () {
      if (siteMenuWrap.classList.contains('active')) {
        setSiteMenuOpen(false);
      }
    });
  }

  // ===== SP ハンバーガー内 gallery / menu ツリーメニュー =====
  // gallery や menu を押すと兄弟項目が折りたたまれ、押した項目が最上部へ移動し、
  // 「戻る」と配下リンクが現れるシームレス遷移。
  function createSiteMenuTree(tree) {
    var toggle = tree.querySelector('[data-global-gallery-toggle]');
    var back = tree.querySelector('[data-global-gallery-back]');
    var panel = tree.querySelector('[data-global-gallery-panel]');
    var nav = tree.closest('.l-pcbg__nav');
    var menuBody = tree.closest('.site-menu-body');
    var scroller = tree.closest('.site-menu');
    var siblings = nav
      ? Array.prototype.filter.call(nav.children, function (li) { return li !== tree; })
      : [];
    var busy = false;
    var animations = [];
    var ghosts = [];
    var runId = 0;

    if (!toggle || !panel) return null;

    function cancelMotion() {
      runId += 1;
      animations.forEach(function (animation) { animation.cancel(); });
      animations = [];
      ghosts.forEach(function (element) { element.remove(); });
      ghosts = [];
    }

    // Measure both layouts once; animate only transforms and opacity between them.
    function transition(expanded, returnFocus) {
      if (busy) return;
      cancelMotion();
      var run = runId;
      var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var before = toggle.getBoundingClientRect();
      var outgoing = expanded ? siblings : [back, panel];
      var incoming = expanded
        ? [back].concat(Array.prototype.slice.call(panel.querySelectorAll('.c-global-gallery-links__item')))
        : siblings;
      var canAnimate = !reduceMotion && typeof toggle.animate === 'function';

      if (canAnimate) {
        outgoing.forEach(function (element) {
          var rect = element.getBoundingClientRect();
          var ghost = element.cloneNode(true);
          ghost.removeAttribute('id');
          ghost.querySelectorAll('[id]').forEach(function (child) { child.removeAttribute('id'); });
          ghost.setAttribute('aria-hidden', 'true');
          ghost.setAttribute('inert', '');
          Object.assign(ghost.style, {
            position: 'fixed', top: rect.top + 'px', left: rect.left + 'px',
            width: rect.width + 'px', height: rect.height + 'px',
            margin: '0', pointerEvents: 'none', transition: 'none'
          });
          element.parentNode.appendChild(ghost);
          ghosts.push(ghost);
          animations.push(ghost.animate([
            { opacity: 1, transform: 'translateY(0)' },
            { opacity: 0, transform: 'translateY(' + (expanded ? '-6' : '6') + 'px)' }
          ], { duration: 150, easing: 'ease-out', fill: 'both' }));
        });
      }

      tree.classList.toggle('is-open', expanded);
      if (menuBody) menuBody.classList.toggle('is-gallery-expanded', expanded);
      toggle.setAttribute('aria-expanded', String(expanded));
      siblings.forEach(function (element) { element.hidden = expanded; });
      back.hidden = !expanded;
      panel.hidden = !expanded;
      if (expanded && scroller) scroller.scrollTop = 0;

      if (canAnimate) {
        busy = true;
        var after = toggle.getBoundingClientRect();
        animations.push(toggle.animate([
          { transform: 'translate(' + (before.left - after.left) + 'px,' + (before.top - after.top) + 'px)' },
          { transform: 'translate(0,0)' }
        ], { duration: 460, easing: 'cubic-bezier(0.22, 1, 0.36, 1)', fill: 'both' }));
        incoming.forEach(function (element, index) {
          animations.push(element.animate([
            { opacity: 0, transform: 'translateY(' + (expanded ? '9' : '-7') + 'px)' },
            { opacity: 1, transform: 'translateY(0)' }
          ], {
            duration: 320, delay: 110 + Math.min(index, 4) * 24,
            easing: 'cubic-bezier(0.22, 1, 0.36, 1)', fill: 'both'
          }));
        });
        Promise.all(animations.map(function (animation) {
          return animation.finished.catch(function () {});
        })).then(function () {
          if (run !== runId) return;
          cancelMotion();
          busy = false;
        });
      }
      if (returnFocus) toggle.focus({ preventScroll: true });
    }

    function clearInline(el) {
      el.style.height = '';
      el.style.marginTop = '';
      el.style.marginBottom = '';
    }

    // アニメーション無しで折りたたみ状態へ同期(初期化・メニュー開閉時)
    function syncCollapsed() {
      cancelMotion();
      tree.classList.remove('is-open');
      if (menuBody) menuBody.classList.remove('is-gallery-expanded');
      toggle.setAttribute('aria-expanded', 'false');
      if (back) { back.hidden = true; back.classList.remove('is-tree-hiding'); clearInline(back); }
      panel.hidden = true; panel.classList.remove('is-tree-hiding'); clearInline(panel);
      siblings.forEach(function (el) {
        el.hidden = false;
        el.classList.remove('is-tree-hiding');
        clearInline(el);
      });
      busy = false;
    }

    function isOpen() {
      return tree.classList.contains('is-open');
    }

    function close(instant, returnFocus) {
      if (instant) {
        syncCollapsed();
      } else if (isOpen()) {
        transition(false, returnFocus);
      }
    }

    syncCollapsed();

    toggle.addEventListener('click', function () {
      if (isOpen()) {
        close(false, true);
      } else if (!busy) {
        transition(true, false);
      }
    });

    if (back) {
      back.addEventListener('click', function () {
        close(false, true);
      });
    }

    return { isOpen: isOpen, close: close };
  }

  var siteMenuTrees = Array.prototype.map.call(
    document.querySelectorAll('.site-menu-wrap [data-global-gallery-menu]'),
    createSiteMenuTree
  ).filter(Boolean);

  function resetGalleryTree() {
    siteMenuTrees.forEach(function (tree) { tree.close(true, false); });
  }

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;

    var openTree = siteMenuTrees.filter(function (tree) { return tree.isOpen(); })[0];
    if (openTree) {
      openTree.close(false, true);
      return;
    }

    if (siteMenuWrap && siteMenuWrap.classList.contains('active')) {
      setSiteMenuOpen(false);
      if (menuToggle) menuToggle.focus();
    }
  });
});




  $(function () {
    $('.playbtn').on('click', function(){ // 再生ボタンが押されたら
        // 親要素を遡ってvideoを探す（兄弟要素だとpタグ等が入った場合に取得できないため）
        var $wrapper = $(this).closest('.p-gallery__single__film');
        var $video = $wrapper.find('.video').get(0);

        if($(this).hasClass('playActive')){
            $video.pause();
        }else{
            $video.play();
        }
    });

    $('.video').on('playing', function(){
        // 親要素を遡ってplaybtnを探す
        var $wrapper = $(this).closest('.p-gallery__single__film');
        $wrapper.find('.playbtn').addClass('playActive'); 
        $(this).attr('controls', ''); // ブラウザが表示する再生ボタンを非表示にするために後から属性付与
    });

    $(".video").on('pause', function(){
        var $wrapper = $(this).closest('.p-gallery__single__film');
        $wrapper.find('.playbtn').removeClass('playActive');
        $(this).removeAttr('controls');
    });

    $('.video').on('ended', function(){ 
        var $wrapper = $(this).closest('.p-gallery__single__film');
        $wrapper.find('.playbtn').removeClass('playActive');
        $(this).removeAttr('controls');
    });
});


// 同じ日付で2回目以降ならローディング画面非表示の設定
var splash_text = $.cookie('accessdate'); // キーが入っていれば年月日を取得
var myD = new Date(); // 日付データを取得
var myYear = String(myD.getFullYear()); // 年
var myMonth = String(myD.getMonth() + 1).padStart(2, '0'); // 月（2桁）
var myDate = String(myD.getDate()).padStart(2, '0'); // 日（2桁）

if (splash_text !== myYear + myMonth + myDate) { // Cookieデータとアクセスした日付を比較
    $("#splash").css("display", "block"); // 1回目はローディングを表示
    setTimeout(function () {
        $("#splash_logo").fadeIn(1500, function () { // 1500ミリ秒かけてロゴがフェードイン
            setTimeout(function () {
                $("#splash_logo").fadeOut(1500); // 1500ミリ秒かけてロゴがフェードアウト
            }, 1500); // 1500ミリ秒後に処理を実行

            // スプラッシュ画面のフェードアウト処理
            setTimeout(function () {
                $("#splash").fadeOut(2000, function () { // 1000ミリ秒かけて画面がフェードアウト
                    // Cookieに現在の日付を保存
                    $.cookie('accessdate', myYear + myMonth + myDate); 

                    // mainを表示
                    $("main").fadeIn(1000); // 1000ミリ秒かけてmainをフェードイン
                });
            }, 1700); // 1700ミリ秒後に処理を実行
        });
    }, 3500); // 1500ミリ秒後に処理を実行
} else {
    $("#splash").css("display", "none"); // 同日2回目のアクセスでローディング画面非表示
    $("main").fadeIn(1000); // mainを表示
}

document.addEventListener('DOMContentLoaded', function () {
  var widget = document.querySelector('[data-consultation-widget]');
  if (!widget) return;

  var launcher = widget.querySelector('[data-consultation-launcher]');
  var panel = widget.querySelector('[data-consultation-panel]');
  var closeButton = widget.querySelector('[data-consultation-close]');
  var messages = widget.querySelector('[data-consultation-messages]');
  var choices = widget.querySelector('[data-consultation-choices]');
  var choiceList = widget.querySelector('[data-consultation-choice-list]');
  var form = widget.querySelector('[data-consultation-form]');
  var helper = widget.querySelector('[data-consultation-helper]');
  var input = widget.querySelector('[data-consultation-input]');
  var textarea = widget.querySelector('[data-consultation-textarea]');
  var honeypotInput = widget.querySelector('[data-consultation-honeypot]');
  var submitButton = widget.querySelector('[data-consultation-submit]');
  var status = widget.querySelector('[data-consultation-status]');
  var lineButton = widget.querySelector('[data-consultation-line]');
  var restartButton = widget.querySelector('[data-consultation-restart]');
  var avatarSrc = widget.getAttribute('data-consultation-avatar');
  var siteMenuWrap = document.querySelector('.site-menu-wrap');
  var lightbox = document.getElementById('js-lightbox');
  var planGuides = window.wfConsultationWidget && window.wfConsultationWidget.planGuides ? window.wfConsultationWidget.planGuides : {};
  var revealThreshold = 180;
  var inputMaxLengths = {
    preferred_location: 500,
    profilebook_wedding_date: 100,
    inquiry_summary: 2000,
    additional_note: 2000,
    name: 100,
    email: 254
  };

  var entrySteps = [
    {
      id: 'consultation_type',
      question: 'こんにちは。どのようなご相談でしょうか？',
      type: 'choice',
      helper: '近い内容をお選びください。',
      options: [
        '前撮り・撮影の相談',
        '空き状況を知りたい',
        'プロフィールブックの作成をお願いしたい',
        '提携や協業について相談したい',
        'その他のご相談'
      ]
    }
  ];

  var customerBranchSteps = [
    {
      id: 'shooting_type',
      question: 'まずは、ご希望の撮影内容をお選びください',
      type: 'choice',
      helper: '今のご希望に近いものをお選びください。',
      options: [
        'ウェディングフォト',
        '前撮りムービー',
        'フォトとムービーの両方',
        'まだ検討中'
      ]
    },
    {
      id: 'preferred_timeframe',
      question: '差し支えなければ、撮影希望時期を教えてください',
      type: 'choice',
      helper: '現時点で近いものをお選びください。',
      options: [
        '1ヶ月以内',
        '3ヶ月以内',
        '半年以内',
        '半年以降',
        'まだ未定'
      ]
    },
    {
      id: 'preferred_area',
      question: 'ご希望の撮影エリアを教えてください',
      type: 'choice',
      helper: '決まっていなければ近いエリア、または未定をお選びください。',
      options: [
        '千葉',
        '東京',
        '埼玉',
        '神奈川',
        'その他',
        'まだ未定'
      ]
    },
    {
      id: 'preferred_location',
      question: '撮影場所が決まっていれば、教えてください',
      type: 'text',
      multiline: true,
      optional: true,
      placeholder: '例）東京駅周辺、城ヶ島、〇〇海浜公園など',
      helper: '具体的なロケーション名や候補地があればご記入ください。未定であれば空欄のままで大丈夫です。',
      buttonLabel: '次へ',
      autocomplete: 'off'
    },
    {
      id: 'name',
      question: 'お名前をお願いいたします',
      type: 'text',
      placeholder: '例）山田 花子',
      helper: 'フルネームでご入力ください。',
      buttonLabel: '次へ',
      autocomplete: 'name'
    },
    {
      id: 'additional_note',
      question: 'ほかにご相談やご希望があれば、ご自由にご記入ください',
      type: 'text',
      multiline: true,
      optional: true,
      placeholder: '特になければ空欄のままでも大丈夫です。',
      helper: '補足したいことがあればお気軽にどうぞ。特になければそのまま次へ進めます。',
      buttonLabel: '次へ',
      autocomplete: 'off'
    },
    {
      id: 'email',
      question: 'ご返信先のメールアドレスをご記入ください',
      type: 'email',
      placeholder: 'example@example.com',
      helper: '担当から返信できるメールアドレスをお願いします。',
      buttonLabel: '送信',
      autocomplete: 'email'
    }
  ];

  var profilebookBranchSteps = [
    {
      id: 'profilebook_wedding_date',
      question: '挙式日がお決まりでしたら教えてください',
      type: 'text',
      optional: true,
      placeholder: '例）2027年4月10日（未定の場合は空欄で大丈夫です）',
      helper: '納品スケジュールの確認に使用します。未定の場合はそのまま次へ進めます。',
      buttonLabel: '次へ',
      autocomplete: 'off'
    },
    {
      id: 'profilebook_quantity',
      question: 'ご希望の部数を教えてください',
      type: 'choice',
      helper: '現時点で近いものをお選びください。',
      options: [
        '20部以下',
        '30部前後',
        '40部前後',
        '50部以上',
        'まだ未定'
      ]
    },
    {
      id: 'profilebook_material_status',
      question: '掲載するお写真や原稿の準備状況を教えてください',
      type: 'choice',
      helper: '現在の状況に近いものをお選びください。',
      options: [
        '写真・原稿ともに準備済み',
        '一部準備中',
        'これから準備する',
        '準備方法から相談したい'
      ]
    },
    {
      id: 'name',
      question: 'お名前をお願いいたします',
      type: 'text',
      placeholder: '例）山田 花子',
      helper: 'フルネームでご入力ください。',
      buttonLabel: '次へ',
      autocomplete: 'name'
    },
    {
      id: 'additional_note',
      question: 'ご希望のデザインやご相談内容があればご記入ください',
      type: 'text',
      multiline: true,
      optional: true,
      placeholder: 'ページ構成、デザインの雰囲気、ご希望の納期など',
      helper: '決まっている範囲で大丈夫です。特になければそのまま次へ進めます。',
      buttonLabel: '次へ',
      autocomplete: 'off'
    },
    {
      id: 'email',
      question: 'ご返信先のメールアドレスをご記入ください',
      type: 'email',
      placeholder: 'example@example.com',
      helper: '担当から返信できるメールアドレスをお願いします。',
      buttonLabel: '送信',
      autocomplete: 'email'
    }
  ];

  var partnershipBranchSteps = [
    {
      id: 'inquiry_topic',
      question: '差し支えなければ、ご相談内容をお選びください',
      type: 'choice',
      helper: '内容に近いものをお選びください。',
      options: [
        '提携について',
        '紹介・掲載について',
        '取材・コラボについて',
        'その他'
      ]
    },
    {
      id: 'inquiry_summary',
      question: '差し支えなければ、ご相談の概要を簡単にご記入ください',
      type: 'text',
      multiline: true,
      placeholder: '例）式場提携や紹介導線について相談したいです。',
      helper: '分かる範囲で構いませんので、概要をご記入ください。',
      buttonLabel: '次へ',
      autocomplete: 'off'
    },
    {
      id: 'name',
      question: '会社名またはお名前をお願いいたします',
      type: 'text',
      placeholder: '例）株式会社◯◯ / 山田 花子',
      helper: 'ご担当者名でも法人名でも問題ありません。',
      buttonLabel: '次へ',
      autocomplete: 'organization'
    },
    {
      id: 'additional_note',
      question: 'ほかに共有しておきたいことがあれば、ご自由にご記入ください',
      type: 'text',
      multiline: true,
      optional: true,
      placeholder: '特になければ空欄のままでも大丈夫です。',
      helper: '補足したいことがあればご記入ください。特になければそのまま次へ進めます。',
      buttonLabel: '次へ',
      autocomplete: 'off'
    },
    {
      id: 'email',
      question: 'ご返信先のメールアドレスをご記入ください',
      type: 'email',
      placeholder: 'example@example.com',
      helper: '担当から返信できるメールアドレスをお願いします。',
      buttonLabel: '送信',
      autocomplete: 'email'
    }
  ];

  var answers = {};
  var currentStepIndex = 0;
  var hasStarted = false;
  var isSubmitting = false;
  var thinkingTimer = null;
  var thinkingIndicator = null;

  function isCustomerBranch() {
    return [
      '前撮り・撮影の相談',
      '空き状況を知りたい'
    ].indexOf(answers.consultation_type) !== -1;
  }

  function isProfilebookBranch() {
    return answers.consultation_type === 'プロフィールブックの作成をお願いしたい';
  }

  function getSteps() {
    if (!answers.consultation_type) {
      return entrySteps;
    }

    if (isCustomerBranch()) {
      return entrySteps.concat(customerBranchSteps);
    }

    return entrySteps.concat(isProfilebookBranch() ? profilebookBranchSteps : partnershipBranchSteps);
  }

  function scrollMessagesToBottom() {
    requestAnimationFrame(function () {
      messages.scrollTop = messages.scrollHeight;
    });
  }

  function createAgentAvatar() {
    if (!avatarSrc) {
      return null;
    }

    var avatar = document.createElement('span');
    avatar.className = 'c-consultation-widget__avatar';

    var avatarFrame = document.createElement('span');
    avatarFrame.className = 'c-consultation-widget__avatar-frame';

    var avatarImage = document.createElement('img');
    avatarImage.src = avatarSrc;
    avatarImage.alt = 'Wataru';

    var avatarName = document.createElement('span');
    avatarName.className = 'c-consultation-widget__avatar-name';
    avatarName.textContent = 'wataru';

    avatarFrame.appendChild(avatarImage);
    avatar.appendChild(avatarFrame);
    avatar.appendChild(avatarName);
    return avatar;
  }

  function setStatus(message, isError) {
    status.textContent = message || '';
    status.classList.toggle('is-error', Boolean(isError));
  }

  function createMessage(text, type) {
    var row = document.createElement('div');
    row.className = 'c-consultation-widget__message c-consultation-widget__message--' + type;

    if (type === 'agent') {
      var avatar = createAgentAvatar();
      if (avatar) {
        row.appendChild(avatar);
      }
    }

    var bubble = document.createElement('div');
    bubble.className = 'c-consultation-widget__bubble';
    bubble.textContent = text;

    row.appendChild(bubble);
    messages.appendChild(row);
    scrollMessagesToBottom();
  }

  function createPlanGuideMessage(plan) {
    if (!plan) return;

    var row = document.createElement('div');
    row.className = 'c-consultation-widget__message c-consultation-widget__message--agent';

    var avatar = createAgentAvatar();
    if (avatar) {
      row.appendChild(avatar);
    }

    var bubble = document.createElement('div');
    bubble.className = 'c-consultation-widget__bubble c-consultation-widget__bubble--plan';

    if (plan.mediaType === 'video' && plan.mediaSrc) {
      var mediaWrap = document.createElement('div');
      mediaWrap.className = 'c-consultation-widget__plan-media-wrap c-consultation-widget__plan-media-wrap--video';

      var video = document.createElement('video');
      video.className = 'c-consultation-widget__plan-media c-consultation-widget__plan-media--video';
      video.src = plan.mediaSrc;
      video.poster = plan.mediaPoster || '';
      video.preload = 'none';
      video.controls = false;
      video.playsInline = true;
      video.setAttribute('playsinline', '');

      var playButton = document.createElement('div');
      playButton.className = 'playbtn c-consultation-widget__plan-play';
      playButton.setAttribute('role', 'button');
      playButton.setAttribute('tabindex', '0');
      playButton.setAttribute('aria-label', '動画を再生');
      playButton.innerHTML = '<span class="playbtn-circle"></span><p></p><p>PLAY</p><p></p>';

      function updateVideoState() {
        var isPlaying = !video.paused && !video.ended;
        mediaWrap.classList.toggle('is-playing', isPlaying);
        playButton.hidden = isPlaying;
      }

      function startVideoPlayback() {
        video.controls = true;
        var playPromise = video.play();
        if (playPromise && typeof playPromise.then === 'function') {
          playPromise.then(updateVideoState).catch(function () {});
        } else {
          updateVideoState();
        }
      }

      playButton.addEventListener('click', function (event) {
        event.preventDefault();
        startVideoPlayback();
      });
      playButton.addEventListener('keydown', function (event) {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          startVideoPlayback();
        }
      });

      video.addEventListener('click', function () {
        if (video.paused) {
          startVideoPlayback();
        }
      });
      video.addEventListener('play', updateVideoState);
      video.addEventListener('pause', updateVideoState);
      video.addEventListener('ended', function () {
        video.controls = false;
        updateVideoState();
      });

      mediaWrap.appendChild(video);
      mediaWrap.appendChild(playButton);
      bubble.appendChild(mediaWrap);
    } else if (plan.mediaSrc) {
      var image = document.createElement('img');
      image.className = 'c-consultation-widget__plan-media c-consultation-widget__plan-media--image';
      image.src = plan.mediaSrc;
      image.alt = plan.mediaAlt || plan.title || '';
      bubble.appendChild(image);
    }

    var title = document.createElement('p');
    title.className = 'c-consultation-widget__plan-title';
    title.textContent = plan.title || '';

    var price = document.createElement('p');
    price.className = 'c-consultation-widget__plan-price';
    price.textContent = plan.price || '';

    var summary = document.createElement('p');
    summary.className = 'c-consultation-widget__plan-summary';
    summary.textContent = plan.summary || '';

    bubble.appendChild(title);
    bubble.appendChild(price);
    bubble.appendChild(summary);

    row.appendChild(bubble);
    messages.appendChild(row);
    scrollMessagesToBottom();
  }

  function removeThinkingIndicator() {
    if (thinkingTimer) {
      clearTimeout(thinkingTimer);
      thinkingTimer = null;
    }

    if (thinkingIndicator && thinkingIndicator.parentNode) {
      thinkingIndicator.parentNode.removeChild(thinkingIndicator);
    }

    thinkingIndicator = null;
  }

  function showThinkingIndicator() {
    removeThinkingIndicator();

    var row = document.createElement('div');
    row.className = 'c-consultation-widget__message c-consultation-widget__message--agent c-consultation-widget__message--thinking';

    var avatar = createAgentAvatar();
    if (avatar) {
      row.appendChild(avatar);
    }

    var bubble = document.createElement('div');
    bubble.className = 'c-consultation-widget__bubble c-consultation-widget__bubble--thinking';
    bubble.innerHTML = '<span></span><span></span><span></span>';

    row.appendChild(bubble);
    messages.appendChild(row);
    thinkingIndicator = row;
    scrollMessagesToBottom();
  }

  function withThinking(callback, delay) {
    showThinkingIndicator();
    thinkingTimer = setTimeout(function () {
      removeThinkingIndicator();
      callback();
    }, delay || 900);
  }

  function showChoices(step) {
    choices.hidden = false;
    form.hidden = true;
    choiceList.innerHTML = '';
    helper.textContent = step.helper || '';

    step.options.forEach(function (option) {
      var button = document.createElement('button');
      button.type = 'button';
      button.className = 'c-consultation-widget__choice';
      button.textContent = option;
      button.addEventListener('click', function () {
        saveAnswer(option);
      });
      choiceList.appendChild(button);
    });
  }

  function showInput(step) {
    choices.hidden = true;
    form.hidden = false;
    helper.textContent = step.helper || '';
    input.hidden = Boolean(step.multiline);
    textarea.hidden = !step.multiline;
    input.type = step.type;
    input.value = !step.multiline ? (answers[step.id] || '') : '';
    input.placeholder = !step.multiline ? (step.placeholder || '') : '';
    input.autocomplete = step.autocomplete || 'off';
    input.setAttribute('aria-label', step.question);
    input.maxLength = inputMaxLengths[step.id] || 2000;
    textarea.value = step.multiline ? (answers[step.id] || '') : '';
    textarea.placeholder = step.multiline ? (step.placeholder || '') : '';
    textarea.setAttribute('aria-label', step.question);
    textarea.maxLength = inputMaxLengths[step.id] || 2000;
    submitButton.textContent = step.buttonLabel || '送信';
    setTimeout(function () {
      if (step.multiline) {
        textarea.focus();
      } else {
        input.focus();
      }
    }, 50);
  }

  function askCurrentStep() {
    var step = getSteps()[currentStepIndex];
    if (!step) return;

    withThinking(function () {
      createMessage(step.question, 'agent');

      if (step.type === 'choice') {
        showChoices(step);
      } else {
        showInput(step);
      }
    }, currentStepIndex === 0 ? 780 : 920);
  }

  function saveAnswer(value) {
    var step = getSteps()[currentStepIndex];
    if (!step) return;

    if (step.id === 'consultation_type') {
      answers = {
        consultation_type: value
      };
    } else {
      answers[step.id] = value;
    }
    createMessage(value || (step.optional ? '特になし' : value), 'user');
    currentStepIndex += 1;
    setStatus('');

    if (currentStepIndex >= getSteps().length) {
      submitAnswers();
      return;
    }

    choices.hidden = true;
    form.hidden = true;
    if (step.id === 'shooting_type' && planGuides[value]) {
      withThinking(function () {
        createPlanGuideMessage(planGuides[value]);
        askCurrentStep();
      }, 900);
      return;
    }

    askCurrentStep();
  }

  function validateInput(value, step) {
    if (step.optional && !value) {
      return '';
    }

    if (!value) {
      return '入力内容をご確認ください。';
    }

    if (step.type === 'email') {
      var emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailPattern.test(value)) {
        return 'メールアドレスの形式をご確認ください。';
      }
    }

    return '';
  }

  function resetConversation() {
    answers = {};
    currentStepIndex = 0;
    isSubmitting = false;
    messages.innerHTML = '';
    removeThinkingIndicator();
    choices.hidden = true;
    form.hidden = true;
    input.hidden = false;
    textarea.hidden = true;
    input.value = '';
    textarea.value = '';
    if (lineButton) {
      lineButton.hidden = true;
    }
    restartButton.hidden = true;
    setStatus('');
    askCurrentStep();
  }

  function updateWidgetReveal() {
    // パネルを開いている間はスクロール位置に関わらず表示を維持する
    if (widget.classList.contains('is-open')) {
      widget.classList.add('is-visible');
      return;
    }
    // 一定量スクロールした時のみ表示し、上に戻ったら隠す
    widget.classList.toggle('is-visible', window.scrollY >= revealThreshold);
  }

  function isOverlayOpen() {
    var isMenuOpen = siteMenuWrap && siteMenuWrap.classList.contains('active');
    var isLightboxOpen = lightbox && lightbox.classList.contains('is-open');

    return Boolean(isMenuOpen || isLightboxOpen);
  }

  function updateWidgetSuppressedState() {
    var shouldSuppress = isOverlayOpen();
    widget.classList.toggle('is-suppressed', shouldSuppress);

    if (shouldSuppress && widget.classList.contains('is-open')) {
      closeWidget();
    }
  }

  function handleWidgetReveal() {
    updateWidgetReveal();
  }

  function openWidget() {
    widget.classList.add('is-open');
    launcher.setAttribute('aria-expanded', 'true');
    panel.setAttribute('aria-hidden', 'false');

    if (!hasStarted) {
      hasStarted = true;
      resetConversation();
      return;
    }

    scrollMessagesToBottom();
    if (!form.hidden) {
      input.focus();
    }
  }

  function closeWidget() {
    widget.classList.remove('is-open');
    launcher.setAttribute('aria-expanded', 'false');
    panel.setAttribute('aria-hidden', 'true');
  }

  function submitAnswers() {
    var requestUrl = window.wfConsultationWidget && window.wfConsultationWidget.ajaxUrl;
    var nonce = window.wfConsultationWidget && window.wfConsultationWidget.nonce;

    if (!requestUrl || !nonce) {
      setStatus('送信設定を読み込めませんでした。', true);
      currentStepIndex = getSteps().length - 1;
      showInput(getSteps()[currentStepIndex]);
      return;
    }

    isSubmitting = true;
    choices.hidden = true;
    form.hidden = true;
    helper.textContent = '';
    setStatus('送信しています...');

    var formData = new URLSearchParams();
    formData.append('action', 'wf_submit_consultation_widget');
    formData.append('nonce', nonce);
    formData.append('consultation_type', answers.consultation_type || '');
    formData.append('shooting_type', answers.shooting_type || '');
    formData.append('preferred_timeframe', answers.preferred_timeframe || '');
    formData.append('preferred_area', answers.preferred_area || '');
    formData.append('preferred_location', answers.preferred_location || '');
    formData.append('profilebook_wedding_date', answers.profilebook_wedding_date || '');
    formData.append('profilebook_quantity', answers.profilebook_quantity || '');
    formData.append('profilebook_material_status', answers.profilebook_material_status || '');
    formData.append('inquiry_topic', answers.inquiry_topic || '');
    formData.append('inquiry_summary', answers.inquiry_summary || '');
    formData.append('additional_note', answers.additional_note || '');
    formData.append('name', answers.name || '');
    formData.append('email', answers.email || '');
    formData.append('page_url', window.location.href);
    formData.append('website', honeypotInput ? honeypotInput.value : '');

    fetch(requestUrl, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
      },
      body: formData.toString()
    })
      .then(function (response) {
        return response.json().then(function (data) {
          return {
            ok: response.ok,
            data: data
          };
        });
      })
      .then(function (result) {
        var payload = result.data && result.data.data ? result.data.data : {};
        var message = payload.message ? payload.message : '送信に失敗しました。';
        if (!result.ok || !result.data.success) {
          var requestError = new Error(message);
          requestError.payload = payload;
          throw requestError;
        }

        withThinking(function () {
          createMessage(message, 'agent');
          setStatus('');
          if (lineButton) {
            if (result.data.data.lineUrl) {
              lineButton.setAttribute('href', result.data.data.lineUrl);
            }
            lineButton.hidden = false;
          }
          restartButton.hidden = false;
        }, 1200);
      })
      .catch(function (error) {
        var payload = error && error.payload ? error.payload : null;

        if (lineButton && payload && payload.lineUrl) {
          lineButton.setAttribute('href', payload.lineUrl);
          lineButton.hidden = false;
        }

        if (payload && payload.savedPostId) {
          createMessage(error.message || '送信に失敗しました。', 'agent');
          setStatus('', false);
          restartButton.hidden = false;
          return;
        }

        currentStepIndex = getSteps().length - 1;
        setStatus(error.message || '送信に失敗しました。時間をおいて再度お試しください。', true);
        restartButton.hidden = false;
        showInput(getSteps()[currentStepIndex]);
      })
      .finally(function () {
        isSubmitting = false;
      });
  }

  launcher.addEventListener('click', function () {
    if (widget.classList.contains('is-open')) {
      closeWidget();
      return;
    }

    openWidget();
  });

  closeButton.addEventListener('click', closeWidget);

  form.addEventListener('submit', function (event) {
    event.preventDefault();
    if (isSubmitting) return;

    var step = getSteps()[currentStepIndex];
    if (!step) return;

    var value = step.multiline ? textarea.value.trim() : input.value.trim();
    var validationMessage = validateInput(value, step);

    if (validationMessage) {
      setStatus(validationMessage, true);
      if (step.multiline) {
        textarea.focus();
      } else {
        input.focus();
      }
      return;
    }

    saveAnswer(value);
  });

  restartButton.addEventListener('click', function () {
    resetConversation();
    if (!widget.classList.contains('is-open')) {
      openWidget();
    }
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' && widget.classList.contains('is-open')) {
      closeWidget();
    }
  });

  if (siteMenuWrap && typeof MutationObserver !== 'undefined') {
    new MutationObserver(updateWidgetSuppressedState).observe(siteMenuWrap, {
      attributes: true,
      attributeFilter: ['class']
    });
  }

  if (lightbox && typeof MutationObserver !== 'undefined') {
    new MutationObserver(updateWidgetSuppressedState).observe(lightbox, {
      attributes: true,
      attributeFilter: ['class']
    });
  }

  updateWidgetReveal();
  window.addEventListener('scroll', handleWidgetReveal, {
    passive: true
  });

  updateWidgetSuppressedState();
});

// ===========================
// Gallery 下部ナビ: 見出しを過ぎたら表示し、上に戻ると隠す
// ===========================
(function () {
  var bottomNav = document.querySelector('.p-gallery-bottom-nav');
  var heading = document.querySelector('.c-sub__h1');

  if (!bottomNav || !heading) {
    return;
  }

  if (!('IntersectionObserver' in window)) {
    // 非対応環境では常に表示しておく
    bottomNav.classList.add('is-visible');
    return;
  }

  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      // 見出しがビューポートから出たら(過ぎたら)表示、戻ったら隠す
      bottomNav.classList.toggle('is-visible', !entry.isIntersecting);
    });
  }, {
    threshold: 0
  });

  observer.observe(heading);
})();

// ===========================
// TOP: ギャラリーカテゴリー
// sticky で積み重なるカードへ、次のカードにどれだけ覆われたか(0〜1)を渡す。
// スクロール自体には介入しない。
// ===========================
(function () {
  var stacks = document.querySelectorAll('.js-home-gallery-stack');
  if (!stacks.length) return;

  var clamp = function (value, min, max) {
    return Math.min(Math.max(value, min), max);
  };

  Array.prototype.forEach.call(stacks, function (stack) {
    var items = Array.prototype.slice.call(stack.querySelectorAll('.js-home-gallery-stack-item'));
    var videos = Array.prototype.slice.call(stack.querySelectorAll('video'));
    var frameRequested = false;
    var isInView = true;

    if (!items.length) return;

    function update() {
      frameRequested = false;

      items.forEach(function (item, index) {
        var next = items[index + 1];
        var progress = 0;

        if (next) {
          var rect = item.getBoundingClientRect();
          var nextTop = next.getBoundingClientRect().top;
          progress = clamp((rect.height - (nextTop - rect.top)) / rect.height, 0, 1);
        }

        item.style.setProperty('--stack-progress', progress.toFixed(3));
      });
    }

    function requestUpdate() {
      if (frameRequested || !isInView) return;
      frameRequested = true;
      window.requestAnimationFrame(update);
    }

    if ('IntersectionObserver' in window) {
      // 画面外では計算しない。表示中は右下の相談ウィジェットがカード下部のボタンに被らないよう隠す。
      new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          isInView = entry.isIntersecting;
          document.body.classList.toggle('is-home-gallery-active', entry.isIntersecting);
          if (isInView) requestUpdate();
        });
      }, { rootMargin: '-30% 0px -30% 0px' }).observe(stack);

      // 動画は見えている間だけ再生する
      var videoObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          var video = entry.target;
          if (entry.isIntersecting) {
            var playPromise = video.play();
            if (playPromise && typeof playPromise.catch === 'function') {
              playPromise.catch(function () {});
            }
          } else {
            video.pause();
          }
        });
      }, { threshold: 0.35 });
      videos.forEach(function (video) {
        videoObserver.observe(video);
      });
    }

    window.addEventListener('scroll', requestUpdate, { passive: true });
    window.addEventListener('resize', requestUpdate, { passive: true });
    update();
  });
})();

// ===========================
// ギャラリー共通: こだわり検索ドロワー
// ===========================
(function () {
  Array.prototype.forEach.call(document.querySelectorAll('.js-gallery-filter-open'), function (openButton) {
    var drawerId = openButton.getAttribute('aria-controls');
    var drawer = drawerId ? document.getElementById(drawerId) : null;
    if (!drawer) return;

    var panel = drawer.querySelector('.p-gallery-filter-drawer__panel');
    var closeButtons = drawer.querySelectorAll('.js-gallery-filter-close');
    var deferredOptions = drawer.querySelectorAll('.js-gallery-filter-option');
    var clearButton = drawer.querySelector('.js-gallery-filter-clear');
    var applyButton = drawer.querySelector('.js-gallery-filter-apply');
    var applyLabel = drawer.querySelector('.js-gallery-filter-apply-label');
    var filterBaseUrl = drawer.getAttribute('data-filter-base-url');
    var initialSelection = {};
    var lastFocused = null;

    Array.prototype.forEach.call(deferredOptions, function (option) {
      if (option.getAttribute('aria-pressed') === 'true') {
        initialSelection[option.getAttribute('data-filter-key')] = option.getAttribute('data-filter-value');
      }
    });

    function selectedOptions() {
      return Array.prototype.filter.call(deferredOptions, function (option) {
        return option.getAttribute('aria-pressed') === 'true';
      });
    }

    function setOptionState(option, isSelected) {
      var check = option.querySelector('.p-gallery-filter-drawer__check');
      option.classList.toggle('is-active', isSelected);
      option.setAttribute('aria-pressed', isSelected ? 'true' : 'false');
      if (check) check.hidden = !isSelected;
    }

    function updateDeferredState() {
      if (!deferredOptions.length) return;

      Array.prototype.forEach.call(drawer.querySelectorAll('.p-gallery-filter-drawer__group'), function (group) {
        var hasSelection = !!group.querySelector('.js-gallery-filter-option[aria-pressed="true"]');
        var state = group.querySelector('.p-gallery-filter-drawer__group-state');
        group.classList.toggle('has-selection', hasSelection);
        if (state) state.hidden = !hasSelection;
      });

      var hasAnySelection = selectedOptions().length > 0;
      if (clearButton) clearButton.disabled = !hasAnySelection;
      if (applyLabel) {
        applyLabel.textContent = hasAnySelection ? '選択した条件で見る' : 'すべてのレポートを見る';
      }
    }

    function resetDeferredSelection() {
      if (!deferredOptions.length) return;
      Array.prototype.forEach.call(deferredOptions, function (option) {
        var key = option.getAttribute('data-filter-key');
        var value = option.getAttribute('data-filter-value');
        setOptionState(option, initialSelection[key] === value);
      });
      updateDeferredState();
    }

    Array.prototype.forEach.call(deferredOptions, function (option) {
      option.addEventListener('click', function () {
        var key = option.getAttribute('data-filter-key');
        var wasSelected = option.getAttribute('aria-pressed') === 'true';

        Array.prototype.forEach.call(deferredOptions, function (otherOption) {
          if (otherOption.getAttribute('data-filter-key') === key) {
            setOptionState(otherOption, false);
          }
        });
        if (!wasSelected) setOptionState(option, true);
        updateDeferredState();
      });
    });

    if (clearButton) {
      clearButton.addEventListener('click', function () {
        Array.prototype.forEach.call(deferredOptions, function (option) {
          setOptionState(option, false);
        });
        updateDeferredState();
      });
    }

    if (applyButton && filterBaseUrl) {
      applyButton.addEventListener('click', function () {
        var destination = new URL(filterBaseUrl, window.location.origin);
        Array.prototype.forEach.call(selectedOptions(), function (option) {
          destination.searchParams.set(
            option.getAttribute('data-filter-key'),
            option.getAttribute('data-filter-value')
          );
        });
        window.location.assign(destination.toString());
      });
    }

    function focusableElements() {
      return Array.prototype.filter.call(
        panel.querySelectorAll('a[href], button:not([disabled]), [tabindex]:not([tabindex="-1"])'),
        function (element) { return element.offsetParent !== null; }
      );
    }

    function openDrawer() {
      lastFocused = document.activeElement;
      resetDeferredSelection();
      drawer.removeAttribute('inert');
      drawer.setAttribute('aria-hidden', 'false');
      openButton.setAttribute('aria-expanded', 'true');
      document.body.classList.add('is-gallery-filter-open');
      drawer.classList.add('is-open');
      window.requestAnimationFrame(function () {
        var closeButton = drawer.querySelector('.p-gallery-filter-drawer__close');
        (closeButton || panel).focus();
      });
    }

    function closeDrawer() {
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      drawer.setAttribute('inert', '');
      openButton.setAttribute('aria-expanded', 'false');
      document.body.classList.remove('is-gallery-filter-open');
      if (lastFocused && typeof lastFocused.focus === 'function') {
        lastFocused.focus();
      }
    }

    openButton.addEventListener('click', openDrawer);
    Array.prototype.forEach.call(closeButtons, function (button) {
      button.addEventListener('click', closeDrawer);
    });

    document.addEventListener('keydown', function (event) {
      if (!drawer.classList.contains('is-open')) return;

      if (event.key === 'Escape') {
        event.preventDefault();
        closeDrawer();
        return;
      }

      if (event.key !== 'Tab') return;
      var focusable = focusableElements();
      if (!focusable.length) {
        event.preventDefault();
        panel.focus();
        return;
      }

      var first = focusable[0];
      var last = focusable[focusable.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    });
  });
})();

// ===========================
// ギャラリー一覧: 一覧を少し進んだら右下にこだわり検索を表示
// ===========================
(function () {
  Array.prototype.forEach.call(document.querySelectorAll('.js-gallery-filter-floating'), function (floatingButton) {
    var drawerId = floatingButton.getAttribute('aria-controls');
    var gallery = document.querySelector('.p-gallery__archive');
    var originalButton = Array.prototype.find.call(
      document.querySelectorAll('.js-gallery-filter-open'),
      function (button) {
        return button.getAttribute('aria-controls') === drawerId;
      }
    );

    if (!drawerId || !gallery || !originalButton) return;

    var galleryTop = 0;
    var ticking = false;
    var revealOffset = 120;

    function syncExpandedState() {
      floatingButton.setAttribute(
        'aria-expanded',
        originalButton.getAttribute('aria-expanded') === 'true' ? 'true' : 'false'
      );
    }

    function measure() {
      galleryTop = gallery.getBoundingClientRect().top + window.pageYOffset;
      update();
    }

    function update() {
      ticking = false;
      floatingButton.classList.toggle('is-visible', window.pageYOffset >= galleryTop + revealOffset);
    }

    function requestUpdate() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(update);
    }

    floatingButton.addEventListener('click', function () {
      floatingButton.focus();
      originalButton.click();
    });

    if (typeof MutationObserver !== 'undefined') {
      new MutationObserver(syncExpandedState).observe(originalButton, {
        attributes: true,
        attributeFilter: ['aria-expanded']
      });
    }

    window.addEventListener('scroll', requestUpdate, { passive: true });
    window.addEventListener('resize', measure, { passive: true });
    window.addEventListener('load', measure);

    syncExpandedState();
    measure();
  });
})();

// ===========================
// Gallery 一覧・詳細ページ: FVの入場アニメーション
// 詳細では画像ズーム＋薄い黒背景、一覧では薄い黒背景だけを立ち上げる
// (実際の動きは .c-sub__h1.is-enter のCSSが担当)
// ===========================
(function () {
  var supportedBodyClasses = [
    'single-gallery',
    'single-gallery-location',
    'post-type-archive-gallery',
    'post-type-archive-gallery-photo',
    'post-type-archive-gallery-location',
    'post-type-archive-gallery-movie'
  ];
  var isSupportedPage = supportedBodyClasses.some(function (className) {
    return document.body.classList.contains(className);
  });
  if (!isSupportedPage) return;

  var hero = document.querySelector('.c-sub__h1');
  if (!hero) return;

  var played = false;
  function play() {
    if (played) return;
    played = true;
    // 初期状態を1フレーム描画してからクラスを付与し、transitionを発火させる
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        hero.classList.add('is-enter');
      });
    });
  }

  if (document.readyState === 'complete') {
    play();
  } else {
    // 画像の読み込み完了後に再生(重いFVでもズームが途中から始まらないように)
    window.addEventListener('load', play);
    // 読み込みが遅い場合のフォールバック
    setTimeout(play, 1800);
  }
})();

// ===========================
// ギャラリー一覧: 無限スクロール(ロケーション/フォト/ムービー共通)
// ページャーの代わりに、末尾のセンチネル(.js-load-more)がビューポートに
// 入ったら admin-ajax で次ページを読み込み、リストへ追記する
// ===========================
(function () {
  var ajaxUrl = window.wfConsultationWidget && window.wfConsultationWidget.ajaxUrl;
  if (!ajaxUrl) return;

  Array.prototype.forEach.call(document.querySelectorAll('.js-load-more'), function (more) {
    var listSelector = more.getAttribute('data-list') || '';
    var leftSelector = more.getAttribute('data-list-left') || '';
    var rightSelector = more.getAttribute('data-list-right') || '';
    var list = listSelector ? document.querySelector(listSelector) : null;
    var leftList = leftSelector ? document.querySelector(leftSelector) : null;
    var rightList = rightSelector ? document.querySelector(rightSelector) : null;
    var hasColumnLists = !!(leftList && rightList);
    var action = more.getAttribute('data-action');
    if ((!list && !hasColumnLists) || !action) return;

    var paged = parseInt(more.getAttribute('data-paged'), 10) || 1;
    var maxPages = parseInt(more.getAttribute('data-max'), 10) || 1;
    var params = {};
    try {
      params = JSON.parse(more.getAttribute('data-params') || '{}');
    } catch (e) {
      params = {};
    }
    var loading = false;
    var observer = null;

    function finish() {
      if (observer) observer.disconnect();
      if (more.parentNode) more.parentNode.removeChild(more);
    }

    function loadNext() {
      if (loading || paged >= maxPages) return;
      loading = true;
      more.classList.add('is-loading');

      var body = new URLSearchParams();
      body.append('action', action);
      body.append('paged', paged + 1);
      Object.keys(params).forEach(function (key) {
        body.append(key, params[key] == null ? '' : params[key]);
      });

      fetch(ajaxUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' },
        body: body.toString()
      })
        .then(function (res) { return res.json(); })
        .then(function (result) {
          if (!result || !result.success || !result.data) {
            finish();
            return;
          }
          if (hasColumnLists && result.data.columns) {
            if (result.data.columns.left) {
              leftList.insertAdjacentHTML('beforeend', result.data.columns.left);
            }
            if (result.data.columns.right) {
              rightList.insertAdjacentHTML('beforeend', result.data.columns.right);
            }
          } else if (result.data.html && list) {
            list.insertAdjacentHTML('beforeend', result.data.html);
          }
          // 追加カードのモノクロ→カラー演出を再初期化(対象がなければ無害)
          if (typeof window.wfInitScrollAnimation === 'function') {
            window.wfInitScrollAnimation();
          }
          // ページ高さが伸びた分をLenisに反映しないと、追加分より下へスクロールできなくなる
          if (window.wfLenis && typeof window.wfLenis.resize === 'function') {
            window.wfLenis.resize();
          }
          paged += 1;
          if (!result.data.hasMore || paged >= maxPages) {
            finish();
          }
        })
        .catch(function () {
          // 失敗時はセンチネルを残し、次回intersectで再試行できるようにする
        })
        .finally(function () {
          loading = false;
          more.classList.remove('is-loading');
        });
    }

    if ('IntersectionObserver' in window) {
      observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) loadNext();
        });
      }, {
        // 少し手前から先読みして、スクロールが止まらないようにする
        rootMargin: '0px 0px 400px 0px',
        threshold: 0
      });
      observer.observe(more);
    } else {
      // 非対応環境: スクロール量で簡易的に判定
      window.addEventListener('scroll', function () {
        var rect = more.getBoundingClientRect();
        if (rect.top < window.innerHeight + 400) loadNext();
      }, { passive: true });
    }
  });
})();
